import "autolink-js";
import React, { Component } from "react";
import uuidv4 from "uuid/v4";
import tealium from "tealium-adapter";
import Header from "../Header";
import ChatForm from "../ChatForm";
import ChatHistory from "../ChatHistory";
import SubNavigation from "../SubNavigation";
import Login from "../Login";
import BackToDomDotCom from "../BackToDomDotCom";
import ForgotPassword from "../ForgotPassword";
import { serialize, isHandheld, oAuthHelper } from "./utils";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import "./css/app.css";

if (process.env.REACT_APP_BUILD_ENV === "twitch") {
  require("./css/twitch.css");
}

function openInNewWindow(url) {
  const win = window.open(url, "_blank");

  win.focus();
}

function openExternalUrl(url) {
  if (process.env.REACT_APP_BUILD_ENV === "twitch") {
    openInNewWindow(url);
  } else {
    window.location = url;
  }
}

class App extends Component {
  getRememberedUserOauth(token, path, timeout) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      const data = {
        grant_type: "refresh_token",
        validator_id: "VoldemortCredValidator",
        client_id: "nolo-rm",
        scope: oAuthHelper.semiLoggedInScope,
        refresh_token: token
      };
      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            resolve(request.responseText);
          } else {
            reject(request);
          }
        }
      };
      if (timeout) request.timeout = timeout;
      request.open("POST", path);
      request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=utf-8"
      );
      request.setRequestHeader("DPZ-Pattern", "Full");
      request.setRequestHeader("Authorization", "Basic bm9sby1ybTo=");
      request.send(serialize(data));
    });
  }

  loginRemeberedUser(response) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      const data = {
        rememberMe: true
      };
      const responseObj = JSON.parse(response);

      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          if (request.status === 200) {
            resolve(request.responseText);
          } else {
            reject(request);
          }
        }
      };

      request.open("POST", `${window.ENVCONFIG.legacy_api}/power/login`);
      request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=utf-8"
      );
      request.setRequestHeader(
        "Authorization",
        `${responseObj.token_type} ${responseObj.access_token}`
      );
      request.send(serialize(data));
    });
  }

  static createAccount() {
    openExternalUrl(
      `${window.ENVCONFIG.root}/en/pages/customer/#/customer/profile/new`
    );
  }

  constructor() {
    super();
    //START CORE-12106
    let isPizzaBuilder = !!~window.location.search
      .split(/\?|&/g)
      .indexOf("pizzabuilder=true");
    const [experienceParam] = window.location.search
      .split(/\?|&/g)
      .filter(param => param.indexOf("abtestexperience") >= 0);
    const pizzaBuilderExperience =
      experienceParam &&
      `AT-1047 - Experience ${experienceParam.split("=")[1]}`;
    let domChatBuilderSession = JSON.parse(
      sessionStorage.getItem("domChatBuilder")
    );
    //END CORE-12106
    this.state = {
      chats: [],
      speechToText: {
        nativeSpeechSupported: isNativeSpeechSupported()
      },
      sessionID: uuidv4(),
      loading: /* START CORE-12106 */ isPizzaBuilder
        ? false
        : /* END CORE-12106 */ true,
      loggedIn: false,
      rememberMe: false,
      customer: {},
      token: {},
      overlay: "",
      dominosContext: {},
      itemCount: "0",
      resolvedQuery: "",
      templateName: "",
      inputSource: "",
      intent: "",
      returnUrl: "",
      //START CORE-12106
      cartId: isPizzaBuilder && domChatBuilderSession.cartId,
      isPizzaBuilder,
      pizzaBuilderExperience,
      authKey:
        (isPizzaBuilder && window.ENVCONFIG.auth_key_pizza_builder) ||
        (isHandheld() && window.ENVCONFIG.auth_key_mobile) ||
        window.ENVCONFIG.auth_key_desktop,
      showBackToBuilder: isPizzaBuilder,
      referrer: ""
      //END CORE-12106
      /* START UNCOMMENT CORE-12106
            authKey: isHandheld() ? window.ENVCONFIG.auth_key_mobile : window.ENVCONFIG.auth_key_desktop
            END UNCOMMENT CORE-12106 */
    };

    //START CORE-12106
    this.backToBuilder = this.backToBuilder.bind(this);
    this.initiateBuilderChat = this.initiateBuilderChat.bind(this);
    //END CORE-12106

    // Start Load Google ReCaptcha V3
    this.dpzRecaptchaReady = new Promise(resolve => {
      window.dpzRecaptchaReady = () => {
        resolve();
      };
    });
    // End Load Google ReCaptcha V3

    this.setTokenObj = this.setTokenObj.bind(this);
    this.setCustomerObj = this.setCustomerObj.bind(this);
    this.logout = this.logout.bind(this);
    this.orderCheckout = this.orderCheckout.bind(this);
    this.addButtonResponse = this.addButtonResponse.bind(this);
    this.addVoiceResponse = this.addVoiceResponse.bind(this);
    this.addChat = this.addChat.bind(this);
    this.showOverlay = this.showOverlay.bind(this);
    this.showLoginOverlay = this.showLoginOverlay.bind(this);
    this.closeOverlay = this.closeOverlay.bind(this);
    this.buildRedirectURL = this.buildRedirectURL.bind(this);
    this.postMessage = this.postMessage.bind(this);
    this.prepareUDO = this.prepareUDO.bind(this);
    this.sendCartToDomDotCom = this.sendCartToDomDotCom.bind(this);
    this.loginRemeberedUser = this.loginRemeberedUser.bind(this);
    this.getRememberedUserOauth = this.getRememberedUserOauth.bind(this);
  }

  componentDidMount() {
    // Start Load Google ReCaptcha V3
    const src = `https://www.google.com/recaptcha/api.js?render=${window.ENVCONFIG.googleRecaptchaKey}&onload=dpzRecaptchaReady`;
    if (
      this.props.flags[
        window.ENVCONFIG.launchDarkly.flags.getGoogleReCaptchaToken
      ] &&
      !document.querySelector(`script[src="${src}"]`)
    ) {
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      script.async = true;
      document.getElementsByTagName("body")[0].appendChild(script);
    }
    // End Load Google ReCaptcha V3

    const tealiumProfile = "webchat";
    const tealiumEnv =
      window.ENVCONFIG.root === "https://www.dominos.com" ? "prod" : "dev";
    tealium.init(tealiumProfile, tealiumEnv, this.prepareUDO, false);
    //START CORE-12106
    if (!this.state.isPizzaBuilder) {
      //END CORE-12106
      this.isCustomerRemembered().then(authenticated => {
        this.postMessage(authenticated ? "try again" : "get started")
          .then(json => this.parseResponse(json))
          .catch(ex =>
            this.setState({
              chats: [
                ...this.state.chats,
                {
                  message: ex,
                  author: "author--dpz"
                }
              ],
              loading: false
            })
          );
      });

      if (process.env.REACT_APP_BUILD_ENV === "twitch") {
        window.Twitch.ext.onAuthorized(({ channelId }) => {
          const referrer = `twitch_${channelId}`;

          this.setState({
            referrer
          });
        });
      }
      //START CORE-12106
    } else {
      this.isCustomerRemembered().then(() => {
        this.initiateBuilderChat();
      });
    }
    //END CORE-12106

    window.sessionStorage.setItem("domChatOrder", 1);
  }

  // Start Load Google ReCaptcha V3
  getReCaptchaV3Token = action => {
    return new Promise(resolve => {
      this.dpzRecaptchaReady.then(() => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(window.ENVCONFIG.googleRecaptchaKey, {
              action
            })
            .then(token => {
              resolve(token);
            });
        });
      });
    });
  };
  // End Load Google ReCaptcha V3

  //START CORE-12106
  backToBuilder(evt) {
    evt.preventDefault();
    window.parent.postMessage(
      {
        action: "close",
        cartId: this.state.cartId
      },
      window.ENVCONFIG.root
    );
  }

  initiateBuilderChat() {
    const clickTaleScript = document.createElement("script");
    clickTaleScript.setAttribute("type", "text/javascript");
    clickTaleScript.setAttribute("src", "clicktale.js");
    document.head.appendChild(clickTaleScript);

    this.postMessage("PIZZA_BUILDER")
      .then(json => {
        this.parseResponse(json);
        tealium.link();
      })
      .catch(ex =>
        this.setState({
          chats: [
            ...this.state.chats,
            {
              message: ex,
              author: "author--dpz"
            }
          ],
          loading: false
        })
      );
  }
  //END CORE-12106

  setTokenObj(token) {
    this.setState({ token });
  }

  setCustomerObj(customer) {
    this.setState({
      customer,
      loggedIn: true,
      loading: false
    });
  }

  setStateAndPostMessage(chatAuthor, inputSource, payload, displayText) {
    const textToDisplay = displayText || payload;
    const author = `author--${chatAuthor}`;
    this.setState({
      chats: [
        ...this.state.chats,
        {
          message: textToDisplay,
          author
        }
      ],
      inputSource
    });
    this.postMessage(payload)
      .then(json => {
        this.parseResponse(json);
        tealium.link();
      })
      .catch(ex =>
        this.setState({
          chats: [
            ...this.state.chats,
            {
              message: ex,
              author: "author--dpz"
            }
          ],
          loading: false
        })
      );
  }

  setOAuthTokenForNolo(response) {
    const tokenObj = JSON.parse(response);
    window.localStorage.setItem(
      "refreshTokens",
      JSON.stringify({ "customer-oauth": tokenObj.refresh_token })
    );
    window.sessionStorage.setItem(
      "accessTokens",
      JSON.stringify({ "customer-oauth": tokenObj.access_token })
    );
    this.setTokenObj(tokenObj);
  }

  getCustomerObject() {
    const cObj = JSON.parse(window.sessionStorage.getItem("Customer"));
    const isLoggedIn = !!cObj && !!cObj.CustomerID;

    if (isLoggedIn) {
      this.getOAuthTokenFromNolo();
    }
    this.setState({
      customer: cObj,
      loggedIn: isLoggedIn
    });
  }

  getOAuthTokenFromNolo() {
    this.setState({
      token: JSON.parse(window.sessionStorage.getItem("accessTokens"))
    });
  }

  isCustomerRemembered() {
    // Are they semi logged in?
    const refreshToken = JSON.parse(localStorage.getItem("refreshTokens"));
    // If the customer is not logged in, but has a refresh token, we will fetch a new auth token.
    return new Promise((resolve, reject) => {
      if (
        !oAuthHelper.isLoggedIn() &&
        refreshToken &&
        refreshToken["customer-oauth"]
      ) {
        this.getRememberedUserOauth(
          refreshToken["customer-oauth"],
          `${window.ENVCONFIG.authProxyService}/auth-proxy-service/token.oauth2`,
          1000
        )
          .then(response => {
            this.setOAuthTokenForNolo(response);
            return this.loginRemeberedUser(response);
          })
          .then(response => {
            this.setCustomerObj(JSON.parse(response));
            resolve(true);
          })
          .catch(() => {
            this.logout();
            resolve(false);
          });
      } else {
        this.getCustomerObject();
        resolve(false);
      }
    });
  }

  showOverlay(overlay, payload) {
    this.setState({ overlay, payload: payload || "" });
  }

  showLoginOverlay() {
    this.showOverlay("login", false);
  }

  closeOverlay(event, tryAgain) {
    if (tryAgain) {
      this.postMessage("try again")
        .then(json => {
          this.parseResponse(json);
          tealium.link();
        })
        .catch(ex =>
          this.setState({
            chats: [
              ...this.state.chats,
              {
                message: ex,
                author: "author--dpz"
              }
            ],
            loading: false
          })
        );
    }
    this.setState({ overlay: "" });
  }

  logout() {
    const request = new XMLHttpRequest();
    const token = JSON.parse(localStorage.getItem("refreshTokens"));
    const data = {
      refresh_token: (token && token["customer-oauth"]) || ""
    };

    request.onreadystatechange = () => {
      if (request.readyState === 4 && request.status === 200) {
        localStorage.removeItem("CID");
        localStorage.removeItem("CID_data");
        localStorage.removeItem("refreshTokens");
        sessionStorage.removeItem("Customer");
        sessionStorage.removeItem("accessTokens");
        this.postMessage("a_user_just_logged_out_of_their_account")
          .then(json => {
            this.parseResponse(json);
            this.setState({
              customer: {},
              loggedIn: false,
              rememberMe: false,
              token: {}
            });
          })
          .catch(ex =>
            this.setState({
              chats: [
                ...this.state.chats,
                {
                  message: ex,
                  author: "author--dpz"
                }
              ],
              loading: false
            })
          );
      }
    };

    request.open("POST", `${window.ENVCONFIG.legacy_api}/power/logout`);
    request.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=utf-8"
    );
    request.send(serialize(data));
  }

  orderCheckout() {
    this.setStateAndPostMessage("customer", "tap", "checkout", "Checkout");
  }

  addButtonResponse(buttonTitle, buttonPayload, parentTitle) {
    const displayText = buttonTitle || parentTitle;
    this.setStateAndPostMessage("customer", "tap", buttonPayload, displayText);
  }

  addVoiceResponse(message, author) {
    this.setStateAndPostMessage(author, "talk", message);
  }

  addChat(message) {
    message.preventDefault();

    if (message.target.newChat.value.length > 0) {
      this.setStateAndPostMessage(
        "customer",
        "type",
        message.target.newChat.value
      );

      message.target.newChat.value = "";
    }
  }

  sendCartToDomDotCom(payload, openInNewTab = false) {
    if (payload && openInNewTab) {
      openExternalUrl(payload);
    } else {
      window.location = this.buildRedirectURL(this.state.returnUrl);
    }
  }

  buildRedirectURL(returnUrl) {
    if (returnUrl) {
      return this.state.returnUrl;
    }
    return `${window.ENVCONFIG.root}${window.ENVCONFIG.local_root}`;
  }

  prepareUDO() {
    return {
      page_name: /* START CORE-12106 */ this.state.isPizzaBuilder
        ? "Builder Chat"
        : /* END CORE-12106 */ "Web Chat",
      group: "Chat",
      subgroup: "Chat",
      device_type: isHandheld() ? "handheld" : "desktop",
      user_logged_in: this.state.loggedIn,
      remember_me: this.state.rememberMe,
      store_id:
        Object.prototype.hasOwnProperty.call(
          this.state.dominosContext,
          "parameters"
        ) && this.state.dominosContext.parameters["store-number"]
          ? this.state.dominosContext.parameters["store-number"]
          : "",
      my_srv_method:
        Object.prototype.hasOwnProperty.call(
          this.state.dominosContext,
          "parameters"
        ) && this.state.dominosContext.parameters["order-type"]
          ? this.state.dominosContext.parameters["order-type"]
          : "",
      is_easy_order: this.isOrderType("easy"),
      is_recent_order: this.isOrderType("recent"),
      event_name: this.state.templateName,
      event_action: this.state.inputSource,
      event_category: this.state.intent,
      event_label: "chat" /* START CORE-12106 */,
      ab_test: this.state.pizzaBuilderExperience || "false"
      /* END CORE-12106 */
    };
  }

  isOrderType(ordType) {
    return (
      Object.prototype.hasOwnProperty.call(
        this.state.dominosContext,
        "parameters"
      ) && this.state.dominosContext.parameters["order-type"] === ordType
    );
  }

  parseResponse(json) {
    let messageObj = {
      template: json.templateName,
      type: "",
      author: "author--dpz",
      message: ""
    };

    let chats = [];
    const loading = false;
    let dominosContext = {};
    const itemCount =
      json.data && json.data.cartItemCount
        ? String(json.data.cartItemCount)
        : "0";
    const intent = json.intent;
    let returnUrl = "";
    if (json.media && json.media.length > 0) {
      // Carousel and Button types end up here
      messageObj = {
        ...messageObj,
        ...{
          suggestions: json.suggestions,
          media: json.media,
          message: json.display && json.display.autoLink()
        }
      };
      chats = [...this.state.chats, messageObj];

      // Cart options
      if (json.intent === "order.details") {
        messageObj.message = "Cart Details";
        messageObj.chatType = "cart";
      }

      // GenericText options
      if (json.media[0].type !== "CAROUSEL" && json.media[0].title) {
        messageObj.message = json.media[0].title;
        json.media[0].title = "";
      }

      if (json.intent === "order.summary") {
        window.sessionStorage.setItem("domChatHasSeenUpsell", true);
      }

      // Return Url options
      if (
        json.media.length === 1 &&
        json.media[0].buttons.length === 1 &&
        json.media[0].buttons[0].type === "web_url"
      ) {
        returnUrl = json.media[0].buttons[0].payload;
      }
    } else if (json.suggestions && json.suggestions.length > 0) {
      // Converts a pure suggestion response to a BUTTON response.
      messageObj = {
        ...messageObj,
        ...{
          suggestions: json.suggestions,
          message: json.display && json.display.autoLink()
        }
      };
      chats = [...this.state.chats, messageObj];
    } else {
      chats = [
        ...this.state.chats,
        {
          message: json.display && json.display.autoLink(),
          author: "author--dpz"
        }
      ];
    }

    this.setState({
      chats,
      loading,
      dominosContext,
      itemCount,
      resolvedQuery: json.query,
      templateName: json.templateName,
      intent,
      returnUrl
    });

    //START CORE-12106
    if (this.state.isPizzaBuilder && json.action === "product-added") {
      setTimeout(
        function() {
          window.parent.postMessage(
            {
              action: "product-added",
              cartId: this.state.cartId
            },
            window.ENVCONFIG.root
          );

          this.setState({
            chats: [
              ...this.state.chats,
              {
                message: "Thanks for chatting - goodbye!",
                author: "author--dpz"
              }
            ],
            showBackToBuilder: false
          });
        }.bind(this),
        1000
      );
    }

    if (this.state.isPizzaBuilder && json.endOfConversation) {
      setTimeout(
        function() {
          window.parent.postMessage(
            {
              action: "error-close",
              cartId: this.state.cartId
            },
            window.ENVCONFIG.root
          );
        }.bind(this),
        1000
      );
    }
    //END CORE-12106
  }

  postMessage(message) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      //START CORE-12106
      const initiateBuilderChatData = {
        event: "PIZZA_BUILDER",
        data: {
          cartId: this.state.cartId
        },
        user: {
          id: this.state.sessionID,
          token:
            this.state.token.access_token ||
            this.state.token["customer-oauth"] ||
            null
        }
      };
      //END CORE-12106
      const data = {
        query: message,
        user: {
          id: this.state.sessionID,
          token:
            this.state.token.access_token ||
            this.state.token["customer-oauth"] ||
            null
        },
        data: {
          referrer: this.state.referrer
        }
      };
      // START CORE-12106
      if (this.state.isPizzaBuilder) {
        data.data = {
          cartId: this.state.cartId
        };
      }
      // END CORE-12106

      this.setState({ loading: true });
      request.onreadystatechange = () => {
        if (request.readyState === 4) {
          switch (request.status) {
            case 401:
              //START CORE-12106
              if (!this.state.isPizzaBuilder)
                //END CORE-12106
                this.isCustomerRemembered().then(() => {
                  resolve(JSON.parse(request.responseText));
                });
              break;
            case 200:
              resolve(JSON.parse(request.responseText));
              break;
            default:
              reject("Sorry something went wrong");
          }
        }
      };
      request.open("POST", window.ENVCONFIG.convo_service);
      request.setRequestHeader(
        "Content-Type",
        "application/json; charset=utf-8"
      );
      request.setRequestHeader("Authorization", `Bearer ${this.state.authKey}`);
      //START CORE-12106
      request.send(
        JSON.stringify(
          message === "PIZZA_BUILDER" ? initiateBuilderChatData : data
        )
      );
      //END CORE-12106
      /* START UNCOMMENT CORE-12106
            request.send(JSON.stringify(data));
            END UNCOMMENT CORE-12106 */
    });
  }

  render() {
    const action = this.state.loggedIn ? this.logout : this.showLoginOverlay;
    //START CORE-12106
    let abClasses = ` ${this.state.isPizzaBuilder && "pizza-builder"} `;
    //END CORE-12106
    return (
      <div
        className={
          /* START CORE-12106 */ abClasses + /* END CORE-12106 */ "chat"
        }
      >
        {/* START CORE-12106 */}
        {!this.state.isPizzaBuilder /* END CORE-12106 */ && (
          <Header
            loggedIn={this.state.loggedIn}
            customerObj={this.state.customer}
            showOverlay={this.showOverlay}
          />
        )
        /* START CORE-12106 */
        }
        {/* END CORE-12106 */}

        <ChatHistory
          chats={this.state.chats}
          addButtonResponse={this.addButtonResponse}
          loading={this.state.loading}
          showOverlay={this.showOverlay}
          logout={this.logout}
          sendCartToDomDotCom={this.sendCartToDomDotCom}
          /* START CORE-12106 */ backToBuilder={this.backToBuilder}
          initiateBuilderChat={this.initiateBuilderChat}
          isPizzaBuilder={this.state.isPizzaBuilder} /* END CORE-12106 */
        />

        {/* START CORE-12106 */}
        {!this.state.isPizzaBuilder /* END CORE-12106 */ && (
          <SubNavigation
            showOverlay={this.showOverlay}
            loggedIn={this.state.loggedIn}
            customerObj={this.state.customer}
            profileButtonAction={action}
            orderCheckout={this.orderCheckout}
            itemCount={this.state.itemCount}
          />
        )
        /* START CORE-12106 */
        }
        {/* END CORE-12106 */}

        {/* START CORE-12106 */}
        {this.state.showBackToBuilder && (
          <a
            href="#backToBuilder"
            className="back-to-builder"
            onClick={this.backToBuilder}
          >
            Start over with classic Pizza Builder
          </a>
        )}
        {/* END CORE-12106 */}

        <ChatForm
          speechEnabled={this.state.speechToText.nativeSpeechSupported}
          addChat={this.addChat}
          addVoiceResponse={this.addVoiceResponse}
          /* START CORE-12106 */ isPizzaBuilder={
            this.state.isPizzaBuilder
          } /* END CORE-12106 */
        />

        {this.state.overlay === "return" /* START CORE-12106 */ &&
        !this.state.isPizzaBuilder /* END CORE-12106 */ && (
            <BackToDomDotCom
              closeOverlay={this.closeOverlay}
              payload={this.state.payload}
              buildRedirectURL={this.buildRedirectURL}
              openExternalUrl={openExternalUrl}
            />
          )}

        {this.state.overlay === "login" /* START CORE-12106 */ &&
        !this.state.isPizzaBuilder /* END CORE-12106 */ && (
            <Login
              setTokenObj={this.setTokenObj}
              setCustomerObj={this.setCustomerObj}
              createAccount={App.createAccount}
              showOverlay={this.showOverlay}
              closeOverlay={this.closeOverlay}
              resolvedQuery={this.state.resolvedQuery}
              postMessage={this.postMessage}
              customerEmail={
                (this.state.customer && this.state.customer.Email) || ""
              }
              getReCaptchaV3Token={this.getReCaptchaV3Token}
            />
          )}

        {this.state.overlay === "forgotPassword" /* START CORE-12106 */ &&
        !this.state.isPizzaBuilder /* END CORE-12106 */ && (
            <ForgotPassword
              showOverlay={this.showOverlay}
              closeOverlay={this.closeOverlay}
            />
          )}
      </div>
    );
  }
}

function isNativeSpeechSupported() {
  return !!(
    window.SpeechRecognition ||
    window.webkitSpeechRecognition ||
    window.mozSpeechRecognition ||
    window.msSpeechRecognition
  );
}

export default withLDConsumer()(App);
